module.exports = __webpack_public_path__ + "img/ywAward-3.d52f0e43.png";